import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMatchDisplayStore = defineStore('matchDisplay', () => {
  const fullscreen = ref(false)
  const showServer = ref(true)
  return { fullscreen, showServer }
})
